import {
    CnNvCommissionEndpoints,
    EmployeeCategoriesEndpoints,
    EmployeeTypeEndpoints,
} from 'app/core/enums/endpoints';

export const commonPairs = {
    'Employee Type': EmployeeTypeEndpoints,
    'Employee Category': EmployeeCategoriesEndpoints,
    'Finances Commission': CnNvCommissionEndpoints,
};
